var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',{staticClass:"side-left",class:_vm.toggleMenu ? 'openMenu' : ''},_vm._l((_vm.filteredMenus),function(menu){return _c('li',{key:menu.uri,staticClass:"nav-item",class:_vm.defaultRoute.menu === menu.uri ? 'show' : '',on:{"click":function($event){$event.preventDefault();return _vm.handleSelectMenu({
        menu: menu.uri,
        submenu: null,
        v2: false,
      })}}},[_c('a',{staticClass:"nav-link",attrs:{"href":("/#/" + (menu.uri) + "/")}},[_c('span',[_vm._v(" "+_vm._s(menu.name)+" ")])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }